<template>
   <div
      id="jumbotron"
      class="jumbotron frontpage-jumbotron rounded-0 position-relative">
      <div
         id="material-wrap"
         v-touch:tap="void 0"
         class="container-fluid container-lg">
         <div
            id="frontFormular"
            class="row">
            <div
               v-if="custom.type === 'wistia'"
               class="col-lg-7 mt-3 mt-md-0"
               :class="{ xs: breakpoint === 'xs' }">
               <wistia-player :video-id="custom.videoId" />
            </div>
            <div
               v-else
               id="main-product-grid"
               class="col-lg-7 position-relative mb-4"
               :class="{ 'xs': breakpoint === 'xs', 'mt-md': small }">
               <div
                  class="my-5"
                  :class="{ 'text-center': true }">
                  <slot>
                     <h1 v-html="headline" />
                  </slot>
                  <h2
                     v-if="subtitle"
                     class="font-weight-normal"
                     v-html="subtitle" />
                  <h2
                     v-else
                     class="font-weight-normal">
                     Vælg forsikringer, sammenlign tilbud og spar op til 30%
                  </h2>
               </div>
               <products-grid
                  id="material-products"
                  class="product-selectors font-non-codensed"
                  :limit="4"
                  :intro="true">
                  <div
                     class="skilt"
                     :style="{
                        width: small ? '110px' : '120px',
                        left: breakpoint === 'xs' ? '0' : '-10px',
                        top: breakpoint === 'xs' ? '-20px' : '-25px',
                     }" />
               </products-grid>
               <submit-products-button wrapper="#main-product-grid" />
            </div>
            <div class="col-lg-5 font-non-codensed px-lg-0">
               <div class="d-flex h-100 w-100 align-items-end justify-content-center">
                  <picture>
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.avif"
                        type="image/avif" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.webp"
                        type="image/webp" />
                     <source
                        srcset="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.png"
                        type="image/jpeg" />
                     <img
                        class="img-fluid align-self-center"
                        src="/wp-content/themes/findforsikring_2015-sommer/2022/images/findforsikring_people.png"
                        alt="Brugere" />
                  </picture>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import SubmitProductsButton from '@components/SubmitProductsButton';
import ProductsGrid from '@components/ProductsGrid';
import WistiaPlayer from '@components/WistiaPlayer';
import { mapGetters } from 'vuex';

export default {
   name: 'FindforsikringJumbo',
   components: {
      WistiaPlayer,
      ProductsGrid,
      SubmitProductsButton,
   },
   props: {
      custom: {
         type: Object,
         default: function () {
            return {};
         },
      },
   },
   computed: {
      ...mapGetters(['breakpoint', 'header', 'containerClass', 'width', 'small']),
      containerClasses() {
         return `${this.containerClass} ${this.breakpoint}`;
      },
      headline() {
         return this.$store.getters.headline;
      },
      landingpage() {
         return this.$store.state.landingpage;
      },
      subtitle() {
         return this.landingpage && this.landingpage.subtitle ? this.landingpage.subtitle : null;
      },
   },
};
</script>

<style lang="scss" scoped>
#jumbotron {
   background-color: var(--ff-stripe-bg);

   //&.car {
   //   --gradient-from: rgba(3, 12, 48, .4);
   //   --gradient-to: rgba(3, 12, 48, .4);
   //   background-image: linear-gradient(0deg, var(--gradient-from), var(--gradient-to)), var(--img-url);
   //   background-size: cover;
   //   background-repeat: no-repeat;
   //   --img-url: url(/wp-content/themes/findforsikring_2015-sommer/2022/images/jumbotron-car.jpg);
   //   background-position: center center;
   //   height: calc(100vh - 114px);
   //   min-height: 250px;
   //}
}

//html.avif #jumbotron.car {
//   --img-url: url(/wp-content/themes/findforsikring_2015-sommer/2022/images/jumbotron-car.avif);
//}
//
//html.webp #jumbotron.car {
//   --img-url: url(/wp-content/themes/findforsikring_2015-sommer/2022/images/jumbotron-car.webp);
//}
#frontFormular {
   padding-top: unset !important;
}

.extra-space {
   height: 2em;
}

.skilt {
   background-size: contain !important;
   height: 39px;
   top: -25px;
   color: var(--ff-blue);
   position: absolute;
   width: 124px;
   z-index: 500;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.png) no-repeat left top
      transparent;
}

#material-wrap {
   font-size: 14px;

   .spacer {
      height: 75px;

      &.xs {
         height: 0;
      }
   }

   &.md {
      font-size: 14px;
   }

   &.sm {
      font-size: 12px;
   }

   &.xs {
      font-size: 10px;

      .extra-space {
         height: 0;
      }

      .spacer.top {
         height: 3em;
      }
   }

   &.md,
   &.lg {
      //.col-md-6 {
      //    padding: 0 !important;
      //}
   }

   .header-spacing {
      height: 0;
      transition: height 0.3s;

      &.active {
         height: 50px;
      }
   }

   h1 {
      //font-size: 270%;
      font-weight: 800;
      font-stretch: 100%;
      margin-top: 0;
   }

   h2 {
      font-size: 170%;
   }

   .col-md-6 {
      //padding: 0 !important;

      //&.xs {
      //    margin: 0 15px;
      //}
   }

   .super-header {
      text-align: center;
      font-size: 120%;
      position: absolute;
      top: -30px;
      left: calc(50% - 3.9em);
   }

   #more-wrap {
      width: 160px;
      margin: 10px auto;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      border-radius: 3px;
      position: relative;

      .more-button {
         //font-family: 'Amaranth', sans-serif;
         font-size: 18px;
      }
   }

   .cell {
      width: 170px;
      margin: 0 auto;
      height: 50px;
   }
}
</style>
